import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin, Phone } from "lucide-react";
import { Logo } from "@/components/brand/Logo";
import { CONTACT, HERO, NAV, SERVICES } from "@/data/siteContent";

export function PublicFooter() {
  return (
    <footer className="bg-[#111111] px-5 py-14 text-white lg:px-8" data-testid="public-footer">
      <div className="mx-auto max-w-[1180px]">
        <div className="grid gap-12 md:grid-cols-[1.3fr_1fr_1fr_1fr]">
          <div>
            <Logo dark />
            <p className="mt-5 max-w-sm text-[15px] leading-relaxed text-white/65">
              {HERO.tagline} A creator marketing partner based in Malaysia, connecting brands with the
              right KOLs and creators.
            </p>
            <a
              href={CONTACT.saltAndSoul.url}
              target="_blank"
              rel="noreferrer noopener"
              data-testid="footer-salt-soul"
              className="mt-6 inline-flex items-center gap-2 text-sm font-bold text-white/70 hover:text-[#F2811D]"
            >
              <Instagram className="h-4 w-4 shrink-0" />
              {CONTACT.saltAndSoul.name} · {CONTACT.saltAndSoul.handle}
            </a>
          </div>

          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.16em] text-white/45">Explore</h3>
            <ul className="mt-5 space-y-3 text-[15px] text-white/75">
              {NAV.map((item) => (
                <li key={item.to}>
                  <Link
                    to={item.to}
                    className="hover:text-[#F2811D]"
                    data-testid={`footer-nav-${item.label.toLowerCase()}`}
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link
                  to="/join"
                  className="hover:text-[#F2811D]"
                  data-testid="footer-nav-join"
                >
                  Join as a creator
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.16em] text-white/45">Services</h3>
            <ul className="mt-5 space-y-3 text-[15px] text-white/75">
              {SERVICES.map((service) => (
                <li key={service.slug}>
                  <Link to="/services" className="hover:text-[#F2811D]">
                    {service.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-xs font-bold uppercase tracking-[0.16em] text-white/45">
              Get in touch
            </h3>
            <ul className="mt-5 space-y-3 text-[15px] text-white/75">
              <li>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-email"
                  className="flex items-center gap-2.5 hover:text-[#F2811D]"
                >
                  <Mail className="h-4 w-4 shrink-0" />
                  {CONTACT.email}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.phoneHref}
                  data-testid="footer-phone"
                  className="flex items-center gap-2.5 hover:text-[#F2811D]"
                >
                  <Phone className="h-4 w-4 shrink-0" />
                  {CONTACT.phone}
                </a>
              </li>
              <li>
                <a
                  href={CONTACT.instagramUrl}
                  target="_blank"
                  rel="noreferrer noopener"
                  data-testid="footer-instagram"
                  className="flex items-center gap-2.5 hover:text-[#F2811D]"
                >
                  <Instagram className="h-4 w-4 shrink-0" />
                  {CONTACT.instagram}
                </a>
              </li>
              <li className="flex items-start gap-2.5 text-white/55">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0" />
                {CONTACT.location}
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col gap-3 border-t border-white/10 pt-7 text-[13px] text-white/45 sm:flex-row sm:items-center sm:justify-between">
          <span>© {new Date().getFullYear()} AnyTribe Marketing. All rights reserved.</span>
          <Link to="/login" data-testid="footer-login-link" className="hover:text-white">
            Client, creator & team login
          </Link>
        </div>
      </div>
    </footer>
  );
}
